export default __webpack_public_path__ + "static/media/logo.22eb2c70.png";